import { appWithTranslation } from 'next-i18next';
import nextI18nextConfiguration from 'localization/constants/nexti18NextConfig';

function withLocalization(App) {
  return appWithTranslation(App, nextI18nextConfiguration);
}

export default withLocalization;
